import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ReservaDataService } from '../../../services/reserva-data.service';
import { ZonaService } from '../../../services/zona.service';
import { CampoService } from '../../../services/campo.service';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'app-step-2',
  imports: [
    ReactiveFormsModule,
    NgForOf
  ],
  templateUrl: './step-2.component.html',
  styleUrl: './step-2.component.css'
})
export class Step2Component {
  @Output() stepCompleted = new EventEmitter<any>();
  step2Form!: FormGroup;

  zonas: any[] = [];
  campos: any[] = [];

  constructor(
    private reservaDataService: ReservaDataService,
    private fb: FormBuilder,
    private zonaService: ZonaService,
    private campoService: CampoService
  ) {}

  ngOnInit(): void {
    // Inicializar el formulario
    this.step2Form = this.fb.group({
      zona: [null],
      campo: [{ value: null, disabled: true }],
      fechaReserva: [null],
      feriado: [false]
    });

    // Cargar datos desde los servicios
    this.loadZonas();

    // Actualizar los campos según la zona seleccionada
    this.step2Form.get('zona')?.valueChanges.subscribe((zona) => {
      if (zona && zona.id) {
        this.loadCamposPorZona(zona.id);
      } else {
        this.campos = [];
        this.step2Form.get('campo')?.disable();
      }
    });
  }

  loadZonas(): void {
    this.zonaService.getZonas().subscribe((data) => {
      this.zonas = data;
    });
  }

  loadCamposPorZona(zonaId: number): void {
    this.zonaService.getCamposByZona(zonaId).subscribe((data) => {
      this.campos = data;
      if (this.campos.length > 0) {
        this.step2Form.get('campo')?.enable();
      } else {
        this.step2Form.get('campo')?.disable();
      }
    });
  }

  getDayTypeId(dateString: string, isHoliday: boolean): number {
    if (isHoliday) {
      return 2; // Feriado se considera como fin de semana (2)
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 1; // Por defecto, día de semana (1) si la fecha es inválida
    }

    const weekdays = new Set([0, 1, 2, 3, 4]); // Lunes a Viernes
    return weekdays.has(date.getDay()) ? 1 : 2; // 1 para día de semana, 2 para fin de semana
  }

  onSubmit(): void {
    if (this.step2Form.valid) {
      const idTipoDia = this.getDayTypeId(
        this.step2Form.value.fechaReserva,
        this.step2Form.value.feriado
      );

      const step2Data = {
        id_campo: this.step2Form.value.campo,
        id_estado: 2,
        fecha_reserva: this.step2Form.value.fechaReserva,
        codigo_pago: null,
        num_recibo: null,
        id_tipo_dia: idTipoDia
      };

      this.reservaDataService.setData('step2', step2Data);
      this.stepCompleted.emit(step2Data);
    }
  }
}
